import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { Button } from "@mui/material";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import CharityElement from "./CharityElement";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

let env = require("./../../../../env");

// props has activeStep
export default function CharityDonationContent({
  isNotMobile = false,
  modeSearchCharity,
  setSelectedCharity,
  confirmCharity
}) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  // const mockData = [
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_c880a830-a0d0-11ed-9a9f-294a7f5a67b4.jpeg",
  //     Title: "The Alex",
  //     Description: "Health. Home. Humanity.",
  //     CharityId: 1
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_efed48f0-8e73-11ea-ba8d-d5d958fc544a.jpeg",
  //     Title: "Megan's Rescue Efforts Society",
  //     Description:
  //       "We rescue and find homes for abused, sick and homeless anima...",
  //     CharityId: 2
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_05771340-a11f-11eb-b770-1395bdf055d2.jpeg",
  //     Title: "Alberta Animal Rescue Crew Society",
  //     Description: "A Compassionate World for All Animals. ",
  //     CharityId: 3
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_bbb255f0-33c7-11ef-8b25-f1a53cbd6bcb.jpeg",
  //     Title: "Janus Academy Society",
  //     Description:
  //       "To empower and support persons with autism and their familie...",
  //     CharityId: 4
  //   },
  //   {
  //     imgPath:
  //       "https://app.skipthedepot.com/img/charity_logo/logo-9z0p8va72jy4l3xmq.jpg",
  //     Title: "The Mustard Seed Calgary",
  //     Description: "",
  //     CharityId: 5
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_a57e4850-b335-11ef-b534-9f03ef4a32b4.png",
  //     Title: "PALS Pet Access League Society",
  //     Description: "",
  //     CharityId: 6
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_ccc71350-a63c-11ec-8e7d-3d97267812df.jpeg",
  //     Title: "Calgary Adaptive Snow Sports ( CADS)",
  //     Description: "",
  //     CharityId: 7
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_af2ee5a0-0f72-11f0-b17c-13c5b866935f.png",
  //     Title: "Distress Centre Calgary",
  //     Description: "",
  //     CharityId: 8
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_a1238780-2053-11f0-a7f6-4b094b9e4176.png",
  //     Title: "Between Friends",
  //     Description: "",
  //     CharityId: 9
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_685d1e60-a430-11ea-8a54-e3deaca5043e.jpeg",
  //     Title: "Calgary Counselling Centre",
  //     Description: "",
  //     CharityId: 10
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_d6d6e680-2c27-11f0-8863-d3b49eb00f7e.png",
  //     Title: "Kindred Connections Society",
  //     Description: "",
  //     CharityId: 11
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_c66829d0-d349-11ea-90a8-3744a97634f4.jpeg",
  //     Title: "Rescue Friends Animal Foundation",
  //     Description: "",
  //     CharityId: 12
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_e76dc970-098e-11eb-bae8-55f3bd538d4a.jpeg",
  //     Title: "West Hillhurst Community Association",
  //     Description: "",
  //     CharityId: 13
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_09f2b690-1ed9-11eb-9167-7569f9e607df.jpeg",
  //     Title: "Colonel Walker Community School Association",
  //     Description: "",
  //     CharityId: 14
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_5ac358b0-7e4c-11ee-8394-6d9da2c4151b.jpeg",
  //     Title: "Louis Riel Parent Council",
  //     Description: "",
  //     CharityId: 15
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_2b93d180-193a-11ef-bc7d-5735fed3c5ee.jpeg",
  //     Title: "Leftovers Foundation",
  //     Description: "",
  //     CharityId: 16
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_e0efb930-d4da-11ee-97b8-d1a1d15fb621.jpeg",
  //     Title: "Radiance Family Society",
  //     Description: "",
  //     CharityId: 17
  //   },
  //   {
  //     imgPath:
  //       "https://production-std-pickup-photos.s3.us-west-2.amazonaws.com/charity_images/CHARITY_1aa48510-1301-11f0-bb22-71a3be68c1b4.png",
  //     Title: "Captain John Palliser Parents Association",
  //     Description: "",
  //     CharityId: 18
  //   }
  // ];
  const [charityData, setCharityData] = useState([]);
  useEffect(() => {
    const charitiesJSON = getFromSessionStorage("charitiesJSON", []);

    if (charitiesJSON !== null) {
      setCharityData(charitiesJSON.charities);
    }
  }, []);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();

  return (
    <>
      <div
        class="ks_flexPanelLayoutB_TopContainer"
        style={kioskstyles.flexPanelLayoutB_TopContainer}
      >
        <SubtitleWrapper isNotMobile={isNotMobile}>
          <div style={kioskstyles.charities.charityModalTextColor}>
            <Translate value="application.theme.charityChooseACharity" />
          </div>
        </SubtitleWrapper>
      </div>
      <div
        class="ks_flexPanelLayoutB_MidContainer_M"
        style={{
          ...kioskstyles.flexPanelLayoutB_MidContainer,
          flexDirection: "column"
          //alignContent: "space-between",
          //flexWrap: "wrap"
        }}
      >
        <div
          style={{
            ...kioskstyles.charities.selectInstruction,
            ...kioskstyles.charities.charityModalTextColor
          }}
        >
          <Translate value="application.theme.charitySelectCharityInstruction" />
        </div>
        <div
          style={{
            //height: "inherit"
            //height: "49vh"
            height: "90%"
          }}
        >
          <div
            id="charityList"
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              height: "inherit",
              overflowY: "auto",
              gap: "1vh"
              // WebkitScrollbar: "none",
              // scrollbarWidth: "none",
              // msOverflowStyle: "none"
            }}
          >
            {charityData &&
              charityData.map((ele, i) => {
                return (
                  // <CharityElement
                  //   imgPath={ele.imgPath}
                  //   Title={ele.Title}
                  //   Description={ele.Description}
                  //   CharityId={ele.CharityId}
                  //   setSelectedCharity={setSelectedCharity}
                  // />
                  <CharityElement
                    imgPath={ele.logoUrl}
                    Title={ele.name}
                    Description={ele.mission}
                    CharityId={ele.charityID}
                    setSelectedCharity={setSelectedCharity}
                  />
                );
              })}
          </div>
        </div>
      </div>
      <div
        style={{
          ...kioskstyles.flexPanelLayoutB_BotContainer,
          //position: "fixed",
          bottom: "10.5vh"
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={modeSearchCharity}
          sx={{
            ...kioskstyles.charities.charitySearchButton,
            ...kioskstyles.textButtons,
            marginBottom: "0px"
          }}
        >
          <Translate value="application.theme.charityFindById" />
        </Button>
      </div>
    </>
  );
}

function getFromSessionStorage(key, defaultValue = null) {
  try {
    const item = sessionStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, fall back to string if it fails
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Error parsing SessionStorage item "${key}":`, error);
    return defaultValue;
  }
}
